/*
  Bâan Kumlaï — Tirage de Noël « feuille d'or à gratter ». 27/10/2026.
  Version feuille d'or : email (newsletter Shopify) → on gratte une feuille d'or → elle révèle le gain ou « pas cette fois ».
  1 inscrit sur 5 gagne : compteur exact dans la Google Sheet (réglage « compteur »), hasard « chance » en secours. Le gain est une VARIANTE À 0 € (même principe que bk-pochette.js) ajoutée toute seule au panier
  dès 3 articles achetés, et retirée si le panier repasse sous 3. Une participation par navigateur.
  Pochette en lin gagnée + pochette offerte dès 5 articles déjà au panier : on ne garde que celle des 5 articles.
  29/10/2026 : la pochette en lin achetée (5,90 €) ne compte plus dans les 3 articles : seuls les joncs et les bagues comptent.
  Réglages (dates, gains, probabilités) : snippets/bk-siamsi.liquid.
*/
(function () {
  'use strict';

  var CFG = window.BK_SIAMSI;
  if (!CFG) return;

  var SEUIL = CFG.seuil || 3;
  var ID_POCHETTE_5 = 50701658063013; // pochette offerte dès 5 articles (bk-pochette.js)
  var ID_POCHETTE_PAYANTE = 50583859003557; // pochette en lin vendue 5,90 €
  var HANDLE_POCHETTE = 'pochette-cadeau-lin-bracelet';
  var CLE = 'bk_siamsi';
  var CLE_ATTENTE = 'bk_siamsi_attente';
  var CLE_FERME = 'bk_siamsi_ferme';
  var CLE_REFUS = 'bk_siamsi_refus';
  var MARQUE = 'Tirage de Noël';
  var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SECTIONS = 'cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer';

  var occupe = false;
  var file = Promise.resolve();
  var vuAvant = false;

  /* ---------- mémoire ---------- */
  function lire(cle) { try { return JSON.parse(localStorage.getItem(cle)); } catch (e) { return null; } }
  function ecrire(cle, v) { try { localStorage.setItem(cle, JSON.stringify(v)); } catch (e) {} }
  function effacer(cle) { try { localStorage.removeItem(cle); } catch (e) {} }
  function sessionRefus(v) {
    try { if (v) sessionStorage.setItem(CLE_REFUS, '1'); return !!sessionStorage.getItem(CLE_REFUS); } catch (e) { return false; }
  }

  function actif() {
    var t = Date.now();
    return t >= CFG.debut && t <= CFG.fin;
  }
  function gainParId(id) {
    for (var i = 0; i < CFG.gains.length; i++) if (CFG.gains[i].id === id) return CFG.gains[i];
    return null;
  }
  function etat() { var e = lire(CLE); return e && (e.perdu || gainParId(e.gain)) ? e : null; }

  // 1 joueur sur 5 gagne (CFG.chance), puis le lot est tiré selon les poids.
  function tirer() {
    if (Math.random() >= (typeof CFG.chance === 'number' ? CFG.chance : 1)) return null;
    var total = 0, i;
    for (i = 0; i < CFG.gains.length; i++) total += CFG.gains[i].poids;
    var r = Math.random() * total;
    for (i = 0; i < CFG.gains.length; i++) {
      r -= CFG.gains[i].poids;
      if (r < 0) return CFG.gains[i];
    }
    return CFG.gains[CFG.gains.length - 1];
  }

  /* ---------- popup ---------- */
  var pop = document.getElementById('bksi');
  function ouvrir(etape) {
    if (!pop) return;
    montrer(etape);
    if (etape !== 'gain') photo();
    pop.hidden = false;
    document.documentElement.classList.add('bksi-ouvert');
    requestAnimationFrame(lancerPaillettes);
  }
  function fermer() {
    if (!pop) return;
    pop.hidden = true;
    arreterPaillettes();
    document.documentElement.classList.remove('bksi-ouvert');
    if (!etat()) ecrire(CLE_FERME, Date.now());
    pastille();
  }
  function montrer(etape) {
    var blocs = pop.querySelectorAll('[data-etape]');
    for (var i = 0; i < blocs.length; i++) blocs[i].hidden = blocs[i].getAttribute('data-etape') !== etape;
    if (etape === 'gain') remplirGain();
    if (etape === 'secouer') requestAnimationFrame(preparerTicket);
  }

  var ICONE = '<svg viewBox="0 0 24 24" fill="none" stroke="#CEAD5F" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M9 10 8 2M12 10V1.5M15 10l1-8"/><path d="M5.5 10h13l-1.2 12.5h-10.6z"/></svg>';

  function photo(src, alt) {
    var img = pop.querySelector('[data-bksi-photo]');
    if (!img) return;
    var cible = src || img.getAttribute('data-defaut');
    if (img.getAttribute('src') === cible) return;
    img.classList.add('bksi--change');
    setTimeout(function () {
      img.onload = function () { img.classList.remove('bksi--change'); };
      img.src = cible;
      img.alt = alt || img.getAttribute('data-alt') || '';
      var defaut = cible === img.getAttribute('data-defaut');
      img.classList.toggle('bksi--defaut', defaut);
      var pl = pop.querySelector('[data-bksi-paillettes]');
      if (pl) pl.hidden = !defaut;
      if (defaut && !pop.hidden) requestAnimationFrame(lancerPaillettes); else if (!defaut) arreterPaillettes();
    }, 250);
  }

  /* ---------- paillettes d'or qui tombent devant le Bouddha ---------- */
  var paillettes = { actif: false, liste: [], cv: null, ctx: null, w: 0, h: 0, avant: 0 };
  var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function nouvellePaillette(haut) {
    return {
      x: Math.random() * paillettes.w,
      y: haut ? -10 - Math.random() * 40 : Math.random() * paillettes.h,
      t: 3 + Math.random() * 6,          // taille
      v: 9 + Math.random() * 14,         // chute (px/s)
      o: Math.random() * Math.PI * 2,    // phase du balancement
      b: 6 + Math.random() * 14,         // amplitude du balancement
      r: Math.random() * Math.PI * 2,    // rotation
      vr: (Math.random() - 0.5) * 2.4,   // vitesse de rotation
      f: [Math.random(), Math.random(), Math.random(), Math.random()] // forme irrégulière
    };
  }

  function lancerPaillettes() {
    if (calme || paillettes.actif) return;
    var cv = pop.querySelector('[data-bksi-paillettes]');
    if (!cv || cv.hidden) return;
    var r = cv.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = Math.round(r.width * dpr);
    cv.height = Math.round(r.height * dpr);
    paillettes.cv = cv;
    paillettes.ctx = cv.getContext('2d');
    paillettes.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    paillettes.w = r.width;
    paillettes.h = r.height;
    if (!paillettes.liste.length) for (var i = 0; i < 18; i++) paillettes.liste.push(nouvellePaillette(false));
    paillettes.actif = true;
    paillettes.avant = performance.now();
    requestAnimationFrame(animerPaillettes);
  }

  function arreterPaillettes() { paillettes.actif = false; }

  function animerPaillettes(maintenant) {
    if (!paillettes.actif) return;
    var dt = Math.min(0.05, (maintenant - paillettes.avant) / 1000);
    paillettes.avant = maintenant;
    var c = paillettes.ctx, w = paillettes.w, h = paillettes.h;
    c.clearRect(0, 0, w, h);
    for (var i = 0; i < paillettes.liste.length; i++) {
      var p = paillettes.liste[i];
      p.y += p.v * dt;
      p.o += dt * 1.3;
      p.r += p.vr * dt;
      if (p.y > h + 12) paillettes.liste[i] = p = nouvellePaillette(true);
      var x = p.x + Math.sin(p.o) * p.b;
      var reflet = 0.5 + 0.5 * Math.cos(p.r * 2);   // la feuille d'or s'allume quand elle se retourne
      c.save();
      c.translate(x, p.y);
      c.rotate(p.r);
      c.scale(1, 0.35 + 0.65 * Math.abs(Math.cos(p.r)));
      c.globalAlpha = 0.45 + 0.5 * reflet;
      c.fillStyle = 'rgb(' + Math.round(196 + 59 * reflet) + ',' + Math.round(150 + 85 * reflet) + ',' + Math.round(60 + 110 * reflet) + ')';
      var t = p.t, f = p.f;
      c.beginPath();
      c.moveTo(-t * (0.6 + 0.4 * f[0]), -t * 0.5);
      c.lineTo(t * (0.5 + 0.5 * f[1]), -t * (0.3 + 0.4 * f[2]));
      c.lineTo(t * (0.4 + 0.5 * f[3]), t * 0.6);
      c.lineTo(-t * (0.3 + 0.5 * f[2]), t * (0.4 + 0.4 * f[0]));
      c.closePath();
      c.fill();
      c.restore();
    }
    requestAnimationFrame(animerPaillettes);
  }

  var PERDU = 'Dommage ! Pas de cadeau cette fois-ci';
  function texteGain(g) { return g.offert || ('1 ' + g.court + ' ' + (g.feminin ? 'offerte' : 'offert')); }

  function remplirGain() {
    var e = etat();
    if (!e) return;
    var note = pop.querySelector('[data-bksi-note]');
    var titre = pop.querySelector('[data-bksi-gain]');
    var cond = pop.querySelector('[data-bksi-cond]');
    var choix = pop.querySelector('[data-bksi-choix]');
    var boutique = pop.querySelector('[data-bksi-boutique]');
    var bravo = pop.querySelector('[data-bksi-bravo]');
    if (bravo) {
      var picto = e.perdu ? CFG.pictoPerdu : CFG.pictoBravo;
      bravo.hidden = !picto;
      if (picto) bravo.src = picto;
    }
    if (e.perdu) {
      note.hidden = true;
      choix.hidden = true;
      titre.textContent = PERDU;
      cond.textContent = 'Merci d\'avoir participé. Vous recevrez nos prochaines offres par email.';
      boutique.textContent = 'Découvrir la boutique';
      photo();
      return;
    }
    var g = gainParId(e.gain);
    note.hidden = false;
    pop.querySelector('[data-bksi-num]').textContent = g.num;
    titre.textContent = texteGain(g);
    boutique.textContent = g.choix ? 'Voir les joncs' : 'Voir la boutique';
    photo(g.image, g.nom);
    choix.hidden = !g.choix;
    if (g.choix) preparerChoix(e);
    cond.textContent = g.choix && !e.choix
      ? 'Choisissez votre jonc. Il s\'ajoute tout seul à votre panier dès ' + SEUIL + ' articles achetés.'
      : 'Il s\'ajoute tout seul à votre panier dès ' + SEUIL + ' articles achetés, jusqu\'au ' + CFG.finTexte + '.';
  }

  function preparerChoix(e) {
    var selM = pop.querySelector('[data-bksi-modele]');
    var selT = pop.querySelector('[data-bksi-taille]');
    var ok = pop.querySelector('[data-bksi-valider]');
    if (!selM.options.length) {
      var groupes = {};
      CFG.joncs.forEach(function (j, i) {
        if (!j.tailles.length) return;
        var g = groupes[j.mm];
        if (!g) { g = document.createElement('optgroup'); g.label = j.mm; groupes[j.mm] = g; selM.appendChild(g); }
        var o = document.createElement('option'); o.value = i; o.textContent = j.nom; g.appendChild(o);
      });
      selM.addEventListener('change', remplirTailles);
      remplirTailles();
    }
    function remplirTailles() {
      var j = CFG.joncs[selM.value];
      selT.innerHTML = '';
      j.tailles.forEach(function (t) {
        var o = document.createElement('option'); o.value = t.sku; o.textContent = t.taille; selT.appendChild(o);
      });
    }
    if (e.choix) ok.textContent = 'Modifier mon jonc';
    ok.onclick = function () {
      var j = CFG.joncs[selM.value];
      var st = etat();
      st.choix = { modele: j.nom, taille: selT.options[selT.selectedIndex].text, sku: selT.value };
      ecrire(CLE, st);
      ok.textContent = 'C\'est noté ✓';
      remplacerLigne().then(function () { synchroniser(); });
      remplirGain();
    };
  }

  /* ---------- feuille d'or à gratter ---------- */
  var ticket = null;
  var decouvert = false;

  function preparerTicket() {
    var e = etat();
    if (!e) return;
    var g = e.perdu ? null : gainParId(e.gain);
    var dessous = pop.querySelector('[data-bksi-dessous]');
    dessous.innerHTML = '';
    // Sous la feuille : la phrase, puis le picto du cadeau (ou celui de « perdu »).
    var txt = document.createElement('span');
    txt.textContent = g ? texteGain(g) : PERDU;
    dessous.appendChild(txt);
    var picto = g ? (g.picto || g.image) : CFG.pictoPerdu;
    if (picto) {
      var im = document.createElement('img');
      im.src = picto; im.alt = ''; im.width = 84; im.height = 84;
      if (g && g.picto) im.className = 'bksi--picto';
      dessous.appendChild(im);
    }

    var lien = pop.querySelector('[data-bksi-secouer]');
    if (lien) lien.hidden = false;
    decouvert = false;

    var cv = pop.querySelector('[data-bksi-or]');
    var w = cv.clientWidth, h = cv.clientHeight;
    if (!w || !h) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = Math.round(w * dpr);
    cv.height = Math.round(h * dpr);
    cv.classList.remove('bksi--parti');
    var ctx = cv.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    peindreOr(ctx, w, h);
    ticket = { cv: cv, ctx: ctx, traits: 0, dernier: null };
  }

  // Vraie photo de feuille d'or (réglage « feuilleOr » du snippet), recadrée comme un object-fit:cover.
  var imgOr = null;
  var URL_OR = CFG.feuilleOr || 'https://cdn.shopify.com/s/files/1/0721/0595/1397/files/Texture_abstraite_de_feuille_d_or_froissee.png?v=1793073786&width=900&format=pjpg';
  if (URL_OR) {
    imgOr = new Image();
    imgOr.crossOrigin = 'anonymous'; // sinon le canvas est « sali » et on ne peut plus mesurer la part grattée
    imgOr.decoding = 'async';
    imgOr.src = URL_OR;
  }

  function peindreOr(ctx, w, h) {
    if (imgOr && imgOr.complete && imgOr.naturalWidth) {
      var iw = imgOr.naturalWidth, ih = imgOr.naturalHeight, k = Math.max(w / iw, h / ih);
      var sw = w / k, sh = h / k;
      ctx.drawImage(imgOr, (iw - sw) / 2, (ih - sh) / 2, sw, sh, 0, 0, w, h);
      texteGratter(ctx, w, h, 'rgba(70,48,10,.55)');
      return;
    }
    if (imgOr && !imgOr.complete) {
      // Photo pas encore là : on repeint dès qu'elle arrive, si personne n'a commencé à gratter.
      imgOr.onload = function () { if (ticket && ticket.traits === 0 && !decouvert) preparerTicket(); };
    }
    var gr = ctx.createLinearGradient(0, 0, w, h);
    gr.addColorStop(0, '#b38a36');
    gr.addColorStop(0.28, '#e6cd86');
    gr.addColorStop(0.5, '#c9a24f');
    gr.addColorStop(0.72, '#efd99a');
    gr.addColorStop(1, '#a87f30');
    ctx.fillStyle = gr;
    ctx.fillRect(0, 0, w, h);
    // Plis froissés : petites lignes brisées, comme une feuille d'or posée à la main.
    for (var i = 0; i < 38; i++) {
      var x = Math.random() * w, y = Math.random() * h, a = (Math.random() - 0.5) * 1.2;
      var clair = Math.random() < 0.55;
      ctx.strokeStyle = clair ? 'rgba(255,247,218,.45)' : 'rgba(118,84,20,.25)';
      ctx.lineWidth = clair ? 1.2 : 0.8;
      ctx.beginPath();
      ctx.moveTo(x, y);
      for (var k = 0; k < 4; k++) {
        a += (Math.random() - 0.5) * 1.4;
        x += Math.cos(a) * (8 + Math.random() * 16);
        y += Math.sin(a) * (8 + Math.random() * 16);
        ctx.lineTo(x, y);
      }
      ctx.stroke();
    }
    for (var j = 0; j < (w * h) / 16; j++) {
      ctx.fillStyle = Math.random() < 0.5 ? 'rgba(255,250,226,.2)' : 'rgba(90,62,12,.12)';
      ctx.fillRect(Math.random() * w, Math.random() * h, 1, 1);
    }
    texteGratter(ctx, w, h, 'rgba(82,60,16,.6)');
  }

  function texteGratter(ctx, w, h, couleur) {
    var police = getComputedStyle(document.documentElement).getPropertyValue('--font-heading-family') || 'serif';
    ctx.fillStyle = couleur;
    ctx.font = '400 19px ' + police;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('Grattez ici', w / 2, h / 2);
  }

  function gratter(x, y) {
    var t = ticket;
    if (!t || decouvert) return;
    var c = t.ctx;
    c.globalCompositeOperation = 'destination-out';
    c.strokeStyle = '#000'; // opaque : sinon la feuille ne s'efface qu'à moitié
    c.lineWidth = 38;
    c.lineCap = 'round';
    c.lineJoin = 'round';
    c.beginPath();
    if (t.dernier) c.moveTo(t.dernier.x, t.dernier.y); else c.moveTo(x - 0.1, y);
    c.lineTo(x, y);
    c.stroke();
    t.dernier = { x: x, y: y };
    var r = t.cv.getBoundingClientRect();
    semerPoussiere(r.left + x, r.top + y, 3 + Math.floor(Math.random() * 3), false);
    if (++t.traits % 6 === 0 && partGrattee(t) > 0.5) decouvrir();
  }

  /* ---------- poussière d'or qui se détache sous le doigt ---------- */
  var poussiere = { cv: null, ctx: null, liste: [], actif: false, avant: 0, dpr: 1 };

  function toilePoussiere() {
    if (poussiere.cv) return poussiere.cv;
    var cv = document.createElement('canvas');
    cv.setAttribute('aria-hidden', 'true');
    cv.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:1002';
    document.body.appendChild(cv);
    poussiere.cv = cv;
    poussiere.ctx = cv.getContext('2d');
    return cv;
  }

  function semerPoussiere(x, y, n, eclat) {
    if (calme) return;
    toilePoussiere();
    for (var i = 0; i < n && poussiere.liste.length < 260; i++) {
      var paillette = eclat || Math.random() < 0.35; // le reste : poudre fine
      var a = eclat ? Math.random() * Math.PI * 2 : -Math.PI / 2 + (Math.random() - 0.5) * 2.4;
      var v = eclat ? 60 + Math.random() * 160 : 20 + Math.random() * 70;
      poussiere.liste.push({
        x: x + (Math.random() - 0.5) * 18,
        y: y + (Math.random() - 0.5) * 18,
        vx: Math.cos(a) * v,
        vy: Math.sin(a) * v,
        t: paillette ? 2.5 + Math.random() * 4.5 : 0.7 + Math.random() * 1.4,
        p: paillette,
        r: Math.random() * Math.PI * 2,
        vr: (Math.random() - 0.5) * 9,
        o: Math.random() * Math.PI * 2,
        vie: 0,
        duree: paillette ? 1.4 + Math.random() * 1.2 : 0.6 + Math.random() * 0.7,
        f: [Math.random(), Math.random(), Math.random()]
      });
    }
    if (!poussiere.actif) {
      var cv = poussiere.cv;
      poussiere.dpr = Math.min(window.devicePixelRatio || 1, 2);
      cv.width = Math.round(innerWidth * poussiere.dpr);
      cv.height = Math.round(innerHeight * poussiere.dpr);
      poussiere.actif = true;
      poussiere.avant = performance.now();
      requestAnimationFrame(animerPoussiere);
    }
  }

  function animerPoussiere(maintenant) {
    var c = poussiere.ctx, l = poussiere.liste;
    var dt = Math.min(0.05, (maintenant - poussiere.avant) / 1000);
    poussiere.avant = maintenant;
    c.setTransform(poussiere.dpr, 0, 0, poussiere.dpr, 0, 0);
    c.clearRect(0, 0, innerWidth, innerHeight);
    for (var i = l.length - 1; i >= 0; i--) {
      var q = l[i];
      q.vie += dt;
      if (q.vie >= q.duree) { l.splice(i, 1); continue; }
      // La feuille d'or est si fine qu'elle flotte : peu de gravité, beaucoup de freinage.
      q.vx *= Math.pow(q.p ? 0.12 : 0.3, dt);
      q.vy = q.vy * Math.pow(q.p ? 0.12 : 0.3, dt) + (q.p ? 90 : 140) * dt;
      q.o += dt * 4;
      q.r += q.vr * dt;
      q.x += (q.vx + (q.p ? Math.sin(q.o) * 22 : 0)) * dt;
      q.y += q.vy * dt;
      var fondu = 1 - q.vie / q.duree;
      var reflet = 0.5 + 0.5 * Math.cos(q.r * 2);
      c.globalAlpha = fondu * (q.p ? 0.55 + 0.45 * reflet : 0.8);
      c.fillStyle = 'rgb(' + Math.round(200 + 55 * reflet) + ',' + Math.round(155 + 85 * reflet) + ',' + Math.round(55 + 120 * reflet) + ')';
      if (q.p) {
        c.save();
        c.translate(q.x, q.y);
        c.rotate(q.r);
        c.scale(1, 0.25 + 0.75 * Math.abs(Math.cos(q.r)));
        var t = q.t;
        c.beginPath();
        c.moveTo(-t * (0.5 + 0.5 * q.f[0]), -t * 0.4);
        c.lineTo(t * (0.4 + 0.6 * q.f[1]), -t * 0.5);
        c.lineTo(t * 0.6, t * (0.3 + 0.5 * q.f[2]));
        c.lineTo(-t * 0.4, t * 0.5);
        c.closePath();
        c.fill();
        c.restore();
      } else {
        c.fillRect(q.x, q.y, q.t, q.t);
      }
    }
    c.globalAlpha = 1;
    if (l.length) requestAnimationFrame(animerPoussiere);
    else { poussiere.actif = false; c.clearRect(0, 0, innerWidth, innerHeight); }
  }

  // Quand la feuille tombe d'un coup : un dernier éclat de paillettes sur tout le ticket.
  function eclatFinal() {
    var cv = pop.querySelector('[data-bksi-or]');
    if (!cv) return;
    var r = cv.getBoundingClientRect();
    for (var i = 0; i < 6; i++) semerPoussiere(r.left + Math.random() * r.width, r.top + Math.random() * r.height, 8, true);
  }

  function partGrattee(t) {
    var d, vide = 0, n = 0;
    try { d = t.ctx.getImageData(0, 0, t.cv.width, t.cv.height).data; }
    catch (err) { return t.traits > 140 ? 1 : 0; } // secours si l'image bloque la lecture du canvas
    for (var i = 3; i < d.length; i += 4 * 23) { n++; if (d[i] < 40) vide++; }
    return n ? vide / n : 0;
  }

  function decouvrir() {
    var e = etat();
    if (!e || decouvert) return;
    decouvert = true;
    if (ticket) ticket.cv.classList.add('bksi--parti');
    eclatFinal();
    var lien = pop.querySelector('[data-bksi-secouer]');
    if (lien) lien.hidden = true;
    e.revele = true;
    ecrire(CLE, e);
    synchroniser();
    setTimeout(function () { montrer('gain'); }, 1500);
  }

  function brancherTicket() {
    var cv = pop.querySelector('[data-bksi-or]');
    if (!cv) return;
    var appui = false;
    function pos(ev) { var r = cv.getBoundingClientRect(); return { x: ev.clientX - r.left, y: ev.clientY - r.top }; }
    cv.addEventListener('pointerdown', function (ev) {
      if (!ticket) preparerTicket();
      if (!ticket) return;
      appui = true;
      ticket.dernier = null;
      try { cv.setPointerCapture(ev.pointerId); } catch (err) {}
      var p = pos(ev);
      gratter(p.x, p.y);
      ev.preventDefault();
    });
    cv.addEventListener('pointermove', function (ev) {
      if (!appui) return;
      var p = pos(ev);
      gratter(p.x, p.y);
    });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (type) {
      cv.addEventListener(type, function () {
        if (!appui) return;
        appui = false;
        if (ticket) { ticket.dernier = null; if (!decouvert && partGrattee(ticket) > 0.5) decouvrir(); }
      });
    });
  }

  function brancherPopup() {
    if (!pop) return;
    pop.addEventListener('click', function (ev) {
      if (ev.target === pop || ev.target.closest('[data-bksi-fermer]')) fermer();
      if (ev.target.closest('[data-bksi-secouer]')) decouvrir();
    });
    brancherTicket();
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && !pop.hidden) fermer(); });

    var form = pop.querySelector('form');
    if (form) form.addEventListener('submit', function (ev) {
      // Le tirage est fait AVANT l'envoi : le gain part en étiquette client (segments Shopify Email).
      if (!CFG.compteur) { enregistrer(form, tirer()); return; }
      // Compteur exact (Google Sheet) : 1 gagnant tous les N inscrits. Hasard seulement si la Sheet ne répond pas.
      ev.preventDefault();
      var bouton = form.querySelector('[type="submit"]');
      if (bouton) { bouton.disabled = true; bouton.textContent = 'Votre feuille d\'or arrive…'; }
      var email = (form.querySelector('[name="contact[email]"]') || {}).value || '';
      var fini = false;
      function suite(g) {
        if (fini) return;
        fini = true;
        enregistrer(form, g);
        HTMLFormElement.prototype.submit.call(form);
      }
      setTimeout(function () { suite(tirer()); }, 9000);
      fetch(CFG.compteur, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify({ email: email }) })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!d || !d.ok) throw new Error('compteur');
          suite(d.gagne ? gainParCode(d.code) : null);
        })
        .catch(function () { suite(tirer()); });
    });
  }

  function gainParCode(code) {
    for (var i = 0; i < CFG.gains.length; i++) if (CFG.gains[i].code === code) return CFG.gains[i];
    return null;
  }

  function enregistrer(form, g) {
    ecrire(CLE_ATTENTE, { gain: g ? g.id : 0, perdu: !g, date: Date.now() });
    var tags = form.querySelector('[name="contact[tags]"]');
    if (tags) tags.value = 'newsletter, tirage-siam-si-noel, siamsi-' + (g ? g.code : 'perdu');
  }

  // Pas de popup par-dessus la bannière cookies de Shopify : on attend qu'elle soit fermée.
  function banniereCookies() {
    var b = document.getElementById('shopify-pc__banner');
    if (!b) return false;
    var s = getComputedStyle(b);
    return s.display !== 'none' && s.visibility !== 'hidden' && b.getBoundingClientRect().height > 0;
  }
  function apresCookies(fn, delai) {
    setTimeout(function essai() {
      if (banniereCookies()) { setTimeout(essai, 1500); return; }
      fn();
    }, delai);
  }

  /* ---------- pastille flottante ---------- */
  function pastille(n) {
    var p = document.getElementById('bksi-pastille');
    if (!p) return;
    var e = etat();
    if (!actif() || (e && e.perdu && e.revele)) { p.hidden = true; return; }
    if (!e) {
      p.innerHTML = ICONE + 'Tirage de Noël';
    } else if (e.perdu) {
      p.innerHTML = ICONE + 'Votre feuille d\'or';
    } else {
      var g = gainParId(e.gain);
      if (typeof n === 'number' && n >= SEUIL) p.innerHTML = ICONE + g.court + ' : ' + (g.feminin ? 'offerte' : 'offert');
      else if (typeof n === 'number') p.innerHTML = ICONE + g.court + ' : encore ' + (SEUIL - n) + (SEUIL - n > 1 ? ' articles' : ' article');
      else p.innerHTML = ICONE + 'Votre cadeau : ' + g.court;
    }
    p.hidden = false;
  }

  /* ---------- panier ---------- */
  function panier() {
    return fetch(racine + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function estTirage(it) { return !!(it.properties && it.properties._tirage); }
  function ligneTirage(c) { for (var i = 0; i < c.items.length; i++) if (estTirage(c.items[i])) return c.items[i]; return null; }
  function aPochette5(c) { for (var i = 0; i < c.items.length; i++) if (c.items[i].variant_id === ID_POCHETTE_5) return true; return false; }
  function nbArticles(c) {
    var n = 0;
    for (var i = 0; i < c.items.length; i++) {
      var it = c.items[i];
      if (estTirage(it) || it.variant_id === ID_POCHETTE_5) continue;
      if (it.variant_id === ID_POCHETTE_PAYANTE || it.handle === HANDLE_POCHETTE) continue; // pochette achetée
      n += it.quantity;
    }
    return n;
  }

  function appliquerSections(sections) {
    if (!sections) return;
    var cibles = { 'cart-drawer': 'cart-drawer', 'cart-icon-bubble': '#cart-icon-bubble', 'main-cart-items': '#main-cart-items', 'main-cart-footer': '#main-cart-footer' };
    Object.keys(cibles).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var cible = document.querySelector(cibles[id]);
      if (!cible) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var source = doc.querySelector(cibles[id]);
      if (source) cible.innerHTML = source.innerHTML;
    });
  }

  function envoyer(url, corps) {
    occupe = true;
    corps.sections = SECTIONS;
    return fetch(racine + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps)
    }).then(function (r) { return r.json(); })
      .then(function (d) { appliquerSections(d.sections); })
      .catch(function () {})
      .then(function () { occupe = false; });
  }

  function proprietes(e) {
    var p = { _tirage: MARQUE };
    if (e.choix) {
      p['Jonc choisi'] = e.choix.modele + ' — taille ' + e.choix.taille;
      p['_sku_reel'] = e.choix.sku;
    }
    return p;
  }

  // Après un changement de jonc : on retire l'ancienne ligne, la synchro remet la bonne.
  function remplacerLigne() {
    return panier().then(function (c) {
      var l = ligneTirage(c);
      if (l) return retirer(l);
    }).catch(function () {});
  }

  function _synchroniser() {
    return panier().then(function (c) {
      var e = etat();
      var ligne = ligneTirage(c);
      var n = nbArticles(c);
      pastille(e ? n : undefined);
      poserBarre(e, n);
      marquerLignes();

      if (!e || !e.revele || e.perdu || !actif()) {
        if (ligne) return retirer(ligne);
        return null;
      }
      var g = gainParId(e.gain);

      if (vuAvant && !ligne && n >= SEUIL) sessionRefus(true);
      vuAvant = !!ligne;

      var doublon = g.code === 'pochette-lin' && aPochette5(c);
      var attendChoix = g.choix && !e.choix;
      var voulu = n >= SEUIL && !doublon && !attendChoix && !sessionRefus();

      if (ligne && (ligne.variant_id !== g.id || !voulu)) {
        return retirer(ligne).then(function () { return voulu ? _synchroniser() : _rafraichir(); });
      }
      if (ligne && ligne.quantity > 1) return envoyer('cart/change.js', { id: ligne.key, quantity: 1 });
      if (!ligne && voulu) {
        vuAvant = true;
        return envoyer('cart/add.js', { items: [{ id: g.id, quantity: 1, properties: proprietes(e) }] }).then(function () {
          return panier().then(function (c2) { poserBarre(e, nbArticles(c2)); marquerLignes(); });
        });
      }
      return null;
    }).catch(function () {});
  }
  function _rafraichir() { return panier().then(function (c) { pastille(etat() ? nbArticles(c) : undefined); poserBarre(etat(), nbArticles(c)); marquerLignes(); }); }

  // Retrait fait par CE script : ce n'est pas un refus de la cliente.
  function retirer(ligne) {
    vuAvant = false;
    return envoyer('cart/change.js', { id: ligne.key, quantity: 0 });
  }

  function synchroniser() {
    file = file.then(_synchroniser);
    return file;
  }

  /* ---------- bandeau dans le panier ---------- */
  function poserBarre(e, n) {
    var html = '';
    if (e && e.revele && !e.perdu && actif()) {
      var g = gainParId(e.gain);
      var ok = n >= SEUIL;
      var texte;
      if (g.choix && !e.choix) texte = 'Vous avez gagné un <strong>' + g.court + '</strong> au tirage de Noël. <a href="#" data-bksi-ouvrir>Choisir mon jonc</a>';
      else if (ok) texte = '<strong>' + g.nom + ' : ' + (g.feminin ? 'offerte' : 'offert') + '</strong> grâce au tirage de Noël.';
      else texte = 'Plus que <strong>' + (SEUIL - n) + (SEUIL - n > 1 ? ' articles' : ' article') + '</strong> pour recevoir votre ' + g.court.toLowerCase() + ' ' + (g.feminin ? 'offerte' : 'offert') + '.';
      var largeur = Math.min(100, Math.round((n / SEUIL) * 100));
      html = '<div class="bksi-barre' + (ok ? ' bksi-barre--ok' : '') + '" data-bksi-barre>' +
        '<div class="bksi-barre__txt">' + ICONE + '<span>' + texte + '</span></div>' +
        '<div class="bksi-barre__jauge"><i style="width:' + largeur + '%"></i></div></div>';
    }
    var cibles = [];
    var tiroir = document.querySelector('cart-drawer');
    if (tiroir && !tiroir.classList.contains('is-empty')) {
      var ancre = tiroir.querySelector('[data-bkpo]') || tiroir.querySelector('.drawer__header');
      if (ancre) cibles.push({ conteneur: tiroir, ancre: ancre });
    }
    var pied = document.querySelector('#main-cart-footer');
    if (pied && document.querySelector('#main-cart-items')) cibles.push({ conteneur: pied, ancre: pied.querySelector('[data-bkpo]'), debut: pied });
    cibles.forEach(function (c) {
      var exist = c.conteneur.querySelector('[data-bksi-barre]');
      if (!html) { if (exist) exist.remove(); return; }
      if (exist) exist.outerHTML = html;
      else if (c.ancre) c.ancre.insertAdjacentHTML('afterend', html);
      else c.debut.insertAdjacentHTML('afterbegin', html);
    });
  }

  function marquerLignes() {
    var liens = document.querySelectorAll('a[href*="tirage-siam-si"]');
    for (var i = 0; i < liens.length; i++) {
      var ligne = liens[i].closest('.cart-item, tr, .cart-drawer__item');
      if (ligne) ligne.classList.add('bksi-ligne');
    }
  }

  /* ---------- branchements ---------- */
  function surveiller() {
    var fetchOrigine = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var chemin = typeof url === 'string' ? url : (url && url.url) || '';
      return fetchOrigine.apply(this, arguments).then(function (rep) {
        // Même principe que bk-pochette.js : après un ajout, le cadeau est posé avant de rendre la
        // réponse, sinon le constructeur de pack part au paiement sans lui (2,5 s au plus).
        if (!occupe && rep.ok && /\/cart\/add/.test(chemin)) {
          return Promise.race([
            synchroniser(),
            new Promise(function (ok) { setTimeout(ok, 2500); })
          ]).then(function () { return rep; });
        }
        if (!occupe && /\/cart\/(change|update|clear)/.test(chemin)) setTimeout(synchroniser, 400);
        return rep;
      });
    };
    var tiroir = document.querySelector('cart-drawer');
    if (tiroir) {
      new MutationObserver(function () {
        if (tiroir.classList.contains('active')) setTimeout(synchroniser, 450);
      }).observe(tiroir, { attributes: true, attributeFilter: ['class'] });
    }
    document.addEventListener('click', function (ev) {
      var o = ev.target.closest && ev.target.closest('[data-bksi-ouvrir]');
      if (!o) return;
      ev.preventDefault();
      var e = etat();
      ouvrir(!e ? 'email' : (e.revele ? 'gain' : 'secouer'));
    });
  }

  function demarrer() {
    if (!actif()) { synchroniser(); return; }
    brancherPopup();
    surveiller();

    // Retour du formulaire newsletter : on passe à la feuille d'or à gratter (étape « secouer »).
    var attente = lire(CLE_ATTENTE);
    if (attente && !etat()) {
      var photoRetour = pop && pop.querySelector('[data-bksi-photo]');
      if (photoRetour) photoRetour.loading = 'eager';
      ecrire(CLE, { gain: attente.gain, perdu: !!attente.perdu, date: attente.date, revele: false });
      effacer(CLE_ATTENTE);
      if (history.replaceState && /customer_posted/.test(location.search)) {
        history.replaceState(null, '', location.pathname + location.hash.replace('#bk-siamsi-form', ''));
      }
      ouvrir('secouer');
    } else {
      var e = etat();
      var ferme = lire(CLE_FERME);
      var dejaFerme = ferme && Date.now() - ferme < (CFG.relanceHeures || 48) * 3600000;
      var page = location.pathname;
      var pageExclue = /\/(cart|checkout|account|challenge)/.test(page);
      // Le popup va s'ouvrir : on charge la photo tout de suite pour qu'elle soit prête à l'affichage.
      if (!pageExclue && (!e ? !dejaFerme : !e.revele)) {
        var photoPop = pop && pop.querySelector('[data-bksi-photo]');
        if (photoPop) photoPop.loading = 'eager';
      }
      if (!e && !dejaFerme && !pageExclue) apresCookies(function () { ouvrir('email'); }, CFG.delai || 3500);
      else if (e && !e.revele && !pageExclue) apresCookies(function () { ouvrir('secouer'); }, 1200);
    }
    pastille();
    synchroniser();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
